import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';

const CustomTableCell = withStyles(theme => ({
    root: {
        padding: '0px 0px 0px 20px',
        fontSize:12
    },
}))(TableCell);

const styles = theme => ({});
class EnhancedTableHead extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tipsOpen:{}
        };
    }
    createSortHandler = property => event => {
        this.props.onSort(event, property);
    };
    
    handleMouseOver(index){
        let target = document.getElementById(index);
        let offsetWidth = target.offsetWidth;
        let scrollWidth = target.scrollWidth;
        if(offsetWidth < scrollWidth){
            let tipsOpen = {};
            tipsOpen[index] = true;
            this.setState({
                tipsOpen
            });
        }
    }
    handleMouseOut(){
        let tipsOpen = {};
        this.setState({
            tipsOpen
        });
    }

    render() {
        const { sord, sidx, columns } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {/*<TableCell padding="checkbox">
                        <Checkbox
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={numSelected === rowCount}
                            onChange={onSelectAllClick}
                        />
                    </TableCell>*/}
                    {columns.map((row, i) => {
                        let index = row.dataIndex;
                        if (row.sortIndex !== undefined) {
                            index = row.sortIndex;
                        }
                        
                        let style = {
                            minWidth: '40px',
                            width: '20%',
                            maxWidth: '120px',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis'
                        };
                        if (row['width']) {
                            style['minWidth'] = row['width'];
                            style['width'] = row['width'];
                            style['maxWidth'] = row['width'];
                        }
                        if (row['minWidth']) {
                            style['minWidth'] = row['minWidth'];
                        }
                        if (row['maxWidth']) {
                            style['maxWidth'] = row['maxWidth'];
                        }
                        if (row['textAlign']) {
                            style['textAlign'] = row['textAlign'];
                        }
                        return (
                            <CustomTableCell
                                key={i}
                                numeric={row.numeric}
                                padding={row.disablePadding ? 'none' : 'default'}
                                sortDirection={false}
                                style={style}
                                id={i}
                                onMouseOver={this.handleMouseOver.bind(this,i)}
                                onMouseOut={this.handleMouseOut.bind(this)}
                            >
                                <Tooltip
                                    open={this.state.tipsOpen[i] === true}
                                    title={row.title}
                                    placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >{row.sorter ? 
                                <TableSortLabel
                                    active={sidx === index}
                                    direction={sord ? sord : 'desc'}
                                    onClick={this.createSortHandler(index)}
                                >
                                    {row.title}
                                </TableSortLabel> : <span>{row.title}</span>}

                                </Tooltip>
                            </CustomTableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    columns: PropTypes.array.isRequired,
    // rowCount: PropTypes.number.isRequired,
    // numSelected: PropTypes.number.isRequired,
    onSort: PropTypes.func,
    // onSelectAllClick: PropTypes.func.isRequired,
    sord: PropTypes.string,
    sidx: PropTypes.string,
    // rowCount: PropTypes.number.isRequired,
};
export default withStyles(styles)(EnhancedTableHead);